<script setup lang="ts">
/**
 * Pastille « environnement de test » : affichée UNIQUEMENT sur les adresses du
 * sandbox (sandbox.donoor.org, dashboard-sandbox.donoor.org), où les équipes
 * techniques des associations font de faux paiements. Ailleurs (prod,
 * staging, local) elle n'apparaît jamais. En bas à gauche : ni décalage de
 * mise en page, ni conflit avec la bulle de chat (en bas à droite).
 */
const { t } = useI18n();
const visible = ref(false);
onMounted(() => {
  visible.value = /^(dashboard-)?sandbox\.donoor\.org$/.test(window.location.hostname);
});
</script>

<template>
  <div
    v-if="visible"
    role="status"
    class="pointer-events-none fixed bottom-4 left-4 z-[60] max-w-[calc(100vw-2rem)] rounded-full bg-amber-500 px-4 py-2 text-xs font-semibold text-white shadow-lg sm:text-sm"
  >
    {{ t("environnement.test") }}
  </div>
</template>
